import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useRole from "./useRole";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import ChangeRole from "./ChangeRole";
import EmptyData from "../../Global/EmptyData";
import CreateRoleModal from "./CreateRoleModal";

const Roles = () => {
  const {
    roleList,
    roleState,
    isLoading,
    selectedId,
    isFetching,
    // tableFields,
    showEditModal,
    showDeleteModal,
    paginationOptions,
    handleEditColumnsClick,
    handleDeleteAction,
    handleCreateClick,
    handleClearClick,
    updateRoleFields,
    handlePagination,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useRole();
  return (
    <div>
      <HeadingGroup
        title={"All Roles"}
        className={`pro-mb-4`}
        buttonTitle={roleList?.data?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={roleState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: roleState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {roleList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={roleList?.data?.result || []}
            uniqueID={"id"}
            fields={roleList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            clear={roleState.clearSelection}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            perpage={roleState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteAction}
            deletable={roleList?.data?.delete_permission}
            editable={roleList?.data?.edit_permission}
            showCheckBox={
              roleList?.data?.delete_permission ||
              roleList?.data?.edit_permission
            }
          />
        )}

        {roleList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={roleState?.currentPage}
            totalPageCount={Math.ceil(
              roleList.data.total_count / roleState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={roleList?.data?.fields || []}
              moduleId={roleList?.data?.module_id}
              updateData={updateRoleFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={showDeleteModal}
          handleClose={handleDeleteAction}
          title={"Change Role"}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
          backdrop="static"
        >
          <ChangeRole
            refetch={refetch}
            roleId={selectedId}
            handleDeleteAction={handleDeleteAction}
            roleListData={roleList?.data?.result}
          />
        </ModalLayout>
        <ModalLayout
          centered={false}
          show={roleState.showCreateModal}
          handleClose={handleCreateClick}
          title={"Create Role"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <CreateRoleModal />
        </ModalLayout>
      </div>
    </div>
  );
};

export default Roles;
